import Link from 'next/link';
import Balancer from 'react-wrap-balancer';

import { Button } from './Button';
import { logEvent } from '../lib/analytics';
import { Column, Row, Section } from './Section';
import { Text } from './Text';

type CallToActionSectionProps = {
  background?: 'BLUE' | 'WHITE';
  title?: string;
  subtitle?: string;
  quoteAction?: boolean;
  agentAction?: boolean;
  quoteActionLabel?: string;
  agentActionLabel?: string;
  quoteActionSecondary?: boolean;
  agentActionSecondary?: boolean;
  planType?: string;
  borderless?: boolean;
} & ({ quoteAction: true } | { agentAction: true });

export const CallToActionSection: React.FC<CallToActionSectionProps> = ({
  background = 'WHITE',
  title = 'Ready to get started?',
  subtitle = 'See plans and pricing today.',
  quoteAction = false,
  agentAction = false,
  quoteActionLabel = 'Get Started',
  agentActionLabel = 'Meet our agents',
  quoteActionSecondary = false,
  agentActionSecondary = false,
  planType,
  borderless,
}) => (
  <Section background={background} borderless={borderless}>
    <Row inset className="items-center">
      <Column className="text-center md:text-left">
        <Text.H2 className="text-4xl md:text-5xl !text-gray-900 !font-black !mb-2">
          <Balancer>{title}</Balancer>
        </Text.H2>
        <Text.Body className="text-xl md:text-2xl !text-blue-500 !font-bold">
          {subtitle}
        </Text.Body>
      </Column>
      <Column className="max-w-[18em] flex flex-col md:justify-center items-end">
        {quoteAction && (
          <Button
            is={Link}
            variant={quoteActionSecondary ? 'SECONDARY' : 'PRIMARY'}
            size="EXTRA_LARGE"
            isFullWidth
            href={`/quote${planType ? `?planType=${planType}` : ''}`}
            analytics={{
              category: 'Navigation',
              name: 'Clicked CTA',
              title,
              subtitle,
              action: 'quote',
              actionLabel: quoteActionLabel,
              planType,
            }}
          >
            {quoteActionLabel}
          </Button>
        )}
        {agentAction && (
          <Button
            is={Link}
            variant={agentActionSecondary ? 'SECONDARY' : 'PRIMARY'}
            size="EXTRA_LARGE"
            isFullWidth
            href="/agents"
            analytics={{
              category: 'Navigation',
              name: 'Clicked CTA',
              title,
              subtitle,
              action: 'agents',
              actionLabel: agentActionLabel,
              planType,
            }}
          >
            {agentActionLabel}
          </Button>
        )}
      </Column>
    </Row>
  </Section>
);
